module.exports = __webpack_public_path__ + "img/other-bg.c9062f38.webp";